module.exports = __webpack_public_path__ + "static/media/liam-left.ddd079cf.PNG";